export default "__VITE_ASSET__Cc_7AXEe__"